import React from 'react';
import SavedItemCard from '@gik/user-profile/components/SavedItemCard/SavedItemCard';
import { Product } from '@gik/core/models/gik/Product';

export interface ISavedProductCard {
  product: Product;
  onDelete?(article: Product): Promise<void>;
}

export default function SavedProductCard({ product, onDelete }: ISavedProductCard) {
  return (
    <SavedItemCard
      item={{
        name: 'product',
        title: product.name,
        link: `/products/${product.slug}`,
        thumbnail: product.thumbnails ? product.thumbnails[0] : null,
        removeItem: () => onDelete(product),
      }}
    />
  );
}
